import React, { useState, useEffect } from 'react';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useAuthenticatedFirestore } from '../hooks/useAuthenticatedFirestore';

const ProfileSettings = () => {
  const { db, isReady, userId } = useAuthenticatedFirestore();
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isReady) return;

    const loadProfile = async () => {
      try {
        const docRef = doc(db, 'pilot', userId);
        const docSnap = await getDoc(docRef);
        // ... handle profile data
      } catch (error) {
        console.error('Error loading profile:', error);
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, [isReady, db, userId]);

  if (!isReady || loading) {
    return <div>Loading...</div>;
  }

  const handleProfilePicUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const storage = getStorage();
      const storageRef = ref(storage, `profile-pics/${userId}`);
      
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);
      
      // Update Firestore document
      const userRef = doc(db, 'pilot', userId);
      await updateDoc(userRef, {
        profilePicture: downloadURL
      });

      // ... handle profile update
    } catch (error) {
      console.error('Error uploading profile picture:', error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="p-4">
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">
          Profile Picture
        </label>
        <input
          type="file"
          accept="image/*"
          onChange={handleProfilePicUpload}
          disabled={uploading}
          className="mt-1 block w-full"
        />
      </div>
      {uploading && <p>Uploading...</p>}
    </div>
  );
};

export default ProfileSettings; 